import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject, InjectionToken, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { RemunerationsTrienniumComponent} from '../RemunerationsTriennium/remunerations-triennium.component';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponent } from '../../ICardComponent';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { Subscription } from 'rxjs';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../../_infrastructure/Utils/UtilsService';

@Component({
    selector: 'remuneration-period-table-edit',
    templateUrl: './remuneration-period-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class RemunerationPeriodTableEditComponent extends TableEditBase<models.RemunerationPeriodEntryVM> implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.scheduleRegimen)
  public scheduleTypes: models.DimensionVM[];

  public professionalClass: string;
  public isMedicalBonif: boolean;
  public isTeacher: boolean;
  public maxStartDate: Date;
  public minEndDate: Date;


  public dateTriennium = new Date(2005, 11, 31);

  //These dates are pending functional validation, should be receiveid as inputs or colected elsewhere
  public minDate: Date;
  public maxDate: Date;

  //Usado para display condicional de tooltips consoante o componente pai do edit caso este edit no futuro seja partilhado por mais de 2 compoenntes terá de ser revisto
  public isParentTriennium = false;

  private mainSubscription: Subscription = new Subscription(); 

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private modalService: ModalService,
    private commonDataService: CommonDataService, private utilsService: UtilsService ,@Optional() public parent?: RemunerationPeriodParent,
    ) {
    super(parent, modalService);
    this.isParentTriennium = (this.parent as ICardComponent).cardConfiguration.cardComponent == 'RemunerationsTrienniumComponent';
    if (this.isParentTriennium) {
      this.minDate = new Date(2003, 0, 1);
      this.maxDate = this.dateTriennium;
    }
    else {
      const lastEffMapPeriod = (this.parent as ICardComponent).parentWorkflow.getStepData("StepMap")?.['EffectivityMap'].effectivityList.map(i => i.endDate).reduce((a, b) => a > b ? a : b);

      this.minDate = new Date(lastEffMapPeriod.getFullYear() - 3, lastEffMapPeriod.getMonth(), lastEffMapPeriod.getDate());
      this.maxDate = lastEffMapPeriod;
    }

    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.scheduleRegimen,
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.scheduleTypes = this.utilsService.getDomainOfDomains(DomainCodes.scheduleRegimen, results).dimensions;
      })
    );


  }

  getMinEndDate() {
    if (isNullOrUndefined(this.item.startDate))
      return undefined;
    else {
      var minEndDate = new Date(this.item.startDate);
      minEndDate.setDate(minEndDate.getDate() + 1);
      return minEndDate;
    }
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.isVersion2()) {
      if (this.parent?.['cardConfiguration']?.['cardCode'] === 'RemunerationsTriennium') {
        this.maxStartDate = new Date("2005-12-31T00:00:00");
        this.minEndDate = new Date("2003-01-01T00:00:00");
      } else {
        this.minEndDate = new Date("2006-01-01T00:00:00");
      }
      if (!this.checkSteps()) {
        this.professionalClass = this.parent['parentWorkflow']?.workflowInstance.formData.StepSubscriberInfo && this.parent['parentWorkflow']?.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus']?.professionalCategoryCode;
      } else {
        this.professionalClass = this.parent['parentWorkflow']?.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
      }
      if (isNullOrUndefined(this.isMedicalBonif))
        this.isMedicalBonif = this.checkIfMedicalBonif();
    }
  }

  ngDoCheck(): void {
    if (this.isVersion2()) {
      if (isNullOrUndefined(this.isMedicalBonif) || isNullOrUndefined(this.isTeacher)) {
        this.isTeacher = this.checkIfTeacher();
        this.isMedicalBonif = this.checkIfMedicalBonif();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  isVersion2() {
    let result = false;
    if (this.parent['parentWorkflow']?.['workflowVersion']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parent['parentWorkflow'].steps.length; i++) {
      if (this.parent['parentWorkflow'].steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  checkIfTeacher() {
    let result = false;
    let profCats = ['9', '35', '10', '34'];
    if (profCats.indexOf(this.professionalClass) >= 0)
      result = true
    return result;
  }

  checkIfMedicalBonif() {
    let result = false;
    let isMedic = false;
    let profCats = ['12', '14'];

    if (profCats.indexOf(this.professionalClass) >= 0)
      isMedic = true

    if (isMedic) {
      let bonifs = ['111', '112', '113', '114'];
      let effMapEntries = this.parent['parentWorkflow']?.['workflowInstance']?.['formData']?.['StepMap']?.['EffectivityMap']?.['effectivityList'];
      for (let i = 0; i < effMapEntries.length; i++) {
        if (this.parent?.['cardConfiguration']?.['cardCode'] === 'RemunerationsTriennium') {
          if (bonifs.indexOf(effMapEntries[i]?.['bonus']) >= 0 && (effMapEntries[i]?.['startDate'] <= this.maxStartDate || effMapEntries[i]?.['endDate'] >= this.minEndDate)) {
            result = true;
            break;
          }
        } else {
          if (bonifs.indexOf(effMapEntries[i]?.['bonus']) >= 0) {
            result = true;
            break;
          }
        }
      }
    }
    return result;
  }

  onEdit(isEdit: boolean) {
    super.markTouched();

    let sValue;

    sValue = this.item.remunerationValue;
    if (sValue !== undefined) {
      sValue = sValue.replace(/\,/g, ".").replace(/\ /g, "");
      this.item.remunerationValue = sValue;
    }

    if (this.hasOverlapingDates() && this.tableItemEditForm.valid) {
      var baseModal = <models.BaseModalVM>{ isError: false, message: "Generic.ConfirmOverlapingPeriods" };
      this.modalService.showModals([baseModal]).subscribe(result => {
        if (result)
          super.onEdit(isEdit);
      });
    }
    else
      super.onEdit(isEdit);

  }

  onRemove(isEdit: boolean) {
    super.markTouched

    if (this.isVersion2()) {
      if (this.isTeacher || this.isMedicalBonif) {
        if (this.parent['cardData'].remunerationsList.length <= 1) {
          var baseModal = <models.BaseModalVM>{ isError: false, message: "Deve existir pelo menos um registo" };
          this.modalService.showModals([baseModal]).subscribe(result => {
            if (result)
              return;
          });
        } else {
          super.onRemove(isEdit);
        }
      } else {
        super.onRemove(isEdit);
      }
    } else {
      super.onRemove(isEdit);
    }
  }

  hasOverlapingDates(): boolean {
    var overlapItemIndex = this.itemList.filter((x, index) => index != (this.isEdit ? this.editIndex : -1)).findIndex(effectivity =>
      (this.item.startDate <= effectivity.endDate && this.item.startDate >= effectivity.startDate) || (this.item.endDate <= effectivity.endDate && this.item.endDate >= effectivity.startDate)
    );
    return overlapItemIndex != -1;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    var object: any;

    //switch (event.target.attributes["ng-reflect-name"].value) {
    switch (event.target.name) {
      case 'startDate': {
        object = new Date(this.item.startDate).toISOString().split('T')[0];
        break;
      }
      case 'endDate': {
        object = new Date(this.item.endDate).toISOString().split('T')[0];
        break;
      }
    }

    DateHelpers.onDateChange(event, dp, object);
  }

  getStartMinEndDate() {
    if (isNullOrUndefined(this.item.endDate))
      return this.maxDate;
    else {

      var minEndDate = new Date(this.maxDate < this.item.endDate ? this.maxDate : this.item.endDate);
      
      return minEndDate;
    }
  }
}

export abstract class RemunerationPeriodParent { };
